import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import LevelOfStressRouteMap from './views/LevelOfStressRouteMap/LevelOfStressRouteMap';
import { HashRouter, Route, Routes } from 'react-router-dom';
import ProposedRoutesMap from './views/ProposedRoutesMap/ProposedRoutesMap';
import GoBostonLevelOfStressMap from './views/GoBostonLevelOfSressMap/GoBostonLevelOfStressMap';
import BostonCyclistsUnionMap from './views/BostonCyclistsUnionMap/BostonCyclistsUnionMap'

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <HashRouter>
      <Routes>
        <Route path="/" element={<ProposedRoutesMap/>}/>
        <Route path="/stress-map" element={<LevelOfStressRouteMap/>}/>
        <Route path="/go-boston" element={<GoBostonLevelOfStressMap/>}/>
        <Route path="/bcu-map" element={<BostonCyclistsUnionMap/>}/>
      </Routes>
    </HashRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
